import Button from '@inqool/uas-web-core/es/components/controls/Button';
import Divider from 'material-ui/Divider';
import * as React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { formValueSelector, reduxForm } from 'redux-form';

import { AutoComplete, AutoCompleteField, Upload, UploadField } from '@components/form';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';
import { ConfigurationProvider } from '@components/provider/configuration';
import * as storage from '@inqool/uas-web-core/es/utils/storage';
import { convertToPdf, saveDocumentAttachment, setProceedingNumber, signPdf } from '@modules/events/_eventsActions';
import { getUserProfile } from '@modules/maps/_mapsActions';
import { required } from '@utils/validators';
import { get } from 'lodash';

const enhance = compose<any, any>(
  withProps(() => {
    return { item: storage.get('id') };
  }),
  entityDetailEnhancer<any, any>({
    getEntity: getUserProfile,
    defaultEntity: {}
  }),
  withNotifications({ setProceedingNumber, saveDocumentAttachment, convertToPdf, signPdf }),
  withState('loader', 'setLoader', false),
  reduxForm({
    form: 'module-events-record-document-create-add-attachment'
  }),
  connect<any>((state, { form }: any) => ({
    file: formValueSelector(form)(state, 'attachment.file')
  })),
  withHandlers({
    onClose: ({ closeItem, change }) => () => {
      change('attachment', undefined);
      closeItem();
    }
  }),
  withConfiguration({}),
  withHandlers({
    onSubmit: ({
      setProceedingNumberNotify,
      convertToPdfNotify,
      signPdfNotify,
      saveDocumentAttachmentNotify,
      setLoader,
      documentId,
      onClose,
      setAttachments,
      attachments,
      entity,
      file,
      change,
      config
    }) => async formData => {
      if (file) {
        setLoader(true);

        let response;
        if (get(config, 'extensions.sign') === 'true' && file.contentType !== 'application/pdf') {
          const pdf = await convertToPdfNotify(formData.attachment.id);

          const pdfContent = await signPdfNotify(entity.certificateId.toUpperCase(), pdf, 'PADES', file.name);
          if (pdfContent != null) {
            response = await saveDocumentAttachmentNotify(documentId, { pdfContent, attachment: formData.attachment });
          }
        } else {
          response = await saveDocumentAttachmentNotify(documentId, formData);
        }

        setLoader(false);

        if (response) {
          setAttachments([...attachments.filter(({ id }) => id !== response.id), response]);
          onClose();
        }
      } else {
        setLoader(true);
        const newFile = await setProceedingNumberNotify(documentId, formData.attachment.id);
        setLoader(false);

        if (newFile) {
          change('attachment.file', newFile);
        }
      }
    }
  })
);

const View: React.SFC<any> = ({ handleSubmit, onSubmit, onClose, loader, files, file }) => {
  const label = (() => {
    if (!file) {
      return 'Přidat';
    }

    switch (file.contentType) {
      case 'application/pdf':
        return 'Odeslat';
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return 'Podepsat a odeslat';
      default:
        return 'Přidat';
    }
  })();

  return (
    <div>
      {loader && <Loader />}
      <form className="layout" onSubmit={handleSubmit(onSubmit)}>
        <Grid fluid={true}>
          <h4>Přidání přílohy</h4>
          <Row>
            <Col md={6}>
              {file ? (
                <UploadField component={Upload} name="attachment.file" overwriteId={file.id} />
              ) : (
                <AutoCompleteField
                  component={AutoComplete}
                  name="attachment"
                  label="Příloha *"
                  items={files}
                  labelFunction={({ name }) => name}
                  valueFunction={value => value}
                  fullWidth={true}
                  validate={required}
                />
              )}
            </Col>
          </Row>
        </Grid>

        <Divider />

        <Button type="submit" label={label} primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={onClose} />
      </form>
    </div>
  );
};

const EnhancedView = enhance(View);
export const EventsFormRecordServicesFormFilesForm = (props: any) => {
  return (
    <ConfigurationProvider>
      <EnhancedView {...props} />
    </ConfigurationProvider>
  );
};



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormRecordServicesFormFilesForm.tsx